var __jsx = React.createElement;
import React from "react";
import AwesomeIcon from "../../AwesomeIcon";
import { faHourglassHalf } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
var AIRAFormFillingLoader = function AIRAFormFillingLoader(_ref) {
  var show = _ref.show;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!show) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm z-50 flex items-center justify-center",
    style: {
      top: 0,
      bottom: "72px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gradient-to-r from-rose-200/70 via-purple-200/60 to-blue-200/70 dark:from-rose-300/50 dark:via-purple-300/40 dark:to-blue-300/50 rounded-2xl py-4 px-6 shadow-2xl max-w-lg mx-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    size: "2xl",
    name: faHourglassHalf,
    className: "text-gray-700 dark:text-gray-200 flex-shrink-0"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-800 dark:text-white text-base font-medium"
  }, t("label.acr.aira_filling_form")))));
};
export default AIRAFormFillingLoader;